import { defineMessages } from 'react-intl';

export const energyEfficiencyFlagMessages = defineMessages({
  energyEfficiency: {
    id: 'ui.flags.energyEfficiency.label',
    defaultMessage: 'Energieeffizienzklasse',
  },
  energyEfficiencyOld: {
    id: 'ui.flags.energyEfficiency.label',
    defaultMessage: 'Energieeffizienzklasse',
  },
});

export const tireEfficiencyFlagMessages = defineMessages({
  fuelEfficiency: {
    id: 'ui.flags.tireEfficiency.fuelEfficiency.label',
    defaultMessage: 'Kraftstoffeffizienz',
  },
  wetGrip: {
    id: 'ui.flags.tireEfficiency.wetGrip.label',
    defaultMessage: 'Nasshaftung',
  },
  externalRollingNoise: {
    id: 'ui.flags.tireEfficiency.externalRollingNoise.label',
    defaultMessage: 'Rollgeräusch',
  },
});
